import { render } from "./BtnBack.vue?vue&type=template&id=0d73cf3d&scoped=true"
import script from "./BtnBack.vue?vue&type=script&lang=js"
export * from "./BtnBack.vue?vue&type=script&lang=js"

import "./BtnBack.vue?vue&type=style&index=0&id=0d73cf3d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d73cf3d"]])

export default __exports__